export default "__VITE_ASSET__DjD1VKhT__"